import React, { useEffect } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { BrandLogo } from '../../components/shared-components/site-header/brand-logo';
import { ListingTips } from '../new-listing/listing-tips';
import '../../hs-theme.css';
import '../new-listing/new-listing.css';

export const NewListingSuccess = () => {
    const location = useLocation();
    const { t } = useTranslation(["listing"]);
    const listingID = location.state?.listing;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // the page only makes sense right after a listing was posted
    if (!listingID) return <Navigate to='/' replace />;

    return (
        <div className='hs hs-nl'>
            <main className='hs-nl-done'>
                <div className='hs-nl-done-card'>
                    <span className='hs-nl-done-icon'>
                        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>
                    </span>
                    <h1>{t('success_title')}</h1>
                    <Link to='/'><BrandLogo /></Link>
                    <p>{t('success_subtitle_1')} {t('success_subtitle_2')}</p>
                    <div className='hs-nl-done-actions'>
                        <Link to={`/oglas/${listingID}`} className='hs-nl-primary'>{t('success_view')}</Link>
                        <Link to='/korisnik/oglasi' className='hs-nl-outline'>{t('success_all_listings')}</Link>
                    </div>
                    {location.state.photoError &&
                        <div className='hs-nl-warning'>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" /></svg>
                            <span>{t('success_photo_error_1')} <Link to={`/postavi-oglas/azuriranje/${listingID}`}>{t('success_photo_error_2')}</Link>.</span>
                        </div>}
                </div>
                <ListingTips plain />
                <Link to='/postavi-oglas' className='hs-nl-another'>+ {t('success_another')}</Link>
            </main>
        </div>
    );
};
